<template>
    <div>
        <BaseModal 
            v-if="visible"
            ModalId="modalId"
            :HideModalFun="onHidden"
            :TitleWindow="$t('PatientLetters.ViewLetter')"
            :width="'50%'"
            :height="'auto'"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: $t('Shared.Download'), variant: 'primary', action: download },                  
            ]"              
            @Close="close"
        >
            <b-row>
                <b-col>
                    <MdRichEdit
                        ref="myEditor" 
                        :value="Value"
                        v-bind:isReadOnly="true"
                        v-bind:Height="'350px'"
                        v-bind:id="'edit_letterContent'"
                        v-bind:HideToolBar="true"
                        v-bind:StartupFocus="false"
                    />
                </b-col>
            </b-row>
        </BaseModal>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import NoteTemplatesService from '@/services/notetemplates.service'
import Utils from '@/common/utils'

export default {
    name: 'LetterViewModal',
    mixins: [ShowMessage, DBFunctions,],

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            modalId: 'LetterViewerDlgId',
            emitCloseEvent: false,
            Value: this.value
        }
    },

    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent= true;
            }
        },
        value(newVal) {
            this.Value = newVal;
        }
    },

    methods: {
        emitEventCancel() {
            this.emitCloseEvent= false;
            this.$emit('update:visible', false);
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.emitCloseEvent= false;
            }
        },

        close() {
            this.emitEventCancel();
        },

        download() {
            NoteTemplatesService
                .download(this.item.headerId, this.item.templateCode, this.item.recId)
                .then((response) => {
                    if (response.status == '200') {
                        const blob = new Blob([response.data], { type: 'application/html' });
                        const url = window.URL.createObjectURL(blob);

                        const link = document.createElement('a');
                        link.href = url;
                        link.download = `lt_${this.item.templateCode}_${Utils.generateUUID()}.html`;
                        
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }
    }
}
</script>